import React from "react";
import UserMenu from "./UserMenu";
import style from "./style.module.scss";

class TopBar extends React.Component {
    render() {
        return (
            <div className={style.topbar}>
                <div className="mr-md-12 mr-auto style_air__menuLeft__logo__name__w3dDc"></div>
                <div className="">
                    <UserMenu/>
                </div>
            </div>
        );
    }
}

export default TopBar;
